import {
  colors,
  fonts,
  fontSizes,
  spacing,
  breakpoints,
} from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

export const styles = stylex.create({
  identity: { minWidth: 0, overflowWrap: "anywhere" },
  details: {
    display: "grid",
    gridTemplateColumns: {
      default: "minmax(0, 1fr) minmax(0, 1fr)",
      [breakpoints.compact]: "minmax(0, 1fr)",
    },
    gap: spacing.space16,
    margin: 0,
    marginBlockStart: spacing.space16,
  },
  summary: {
    cursor: "pointer",
    fontFamily: fonts.interface,
    fontSize: fontSizes.label,
    color: colors.foreground,
    outlineColor: colors.foreground,
    outlineOffset: 3,
    outlineStyle: { default: "none", ":focus-visible": "solid" },
    outlineWidth: 2,
  },
  entry: { display: "grid", gap: spacing.space4, minWidth: 0 },
  value: { margin: 0, overflowWrap: "anywhere" },
  reference: {
    backgroundColor: colors.codeSurface,
    fontFamily: fonts.mono,
    padding: spacing.space12,
    overflowWrap: "anywhere",
    margin: 0,
    userSelect: "all",
  },
});
